import { EntityState } from '@ngrx/entity';
import { contactAdapter } from './message.adapters';
import { Chat } from '@app/core/models';
import { NewChatRecipient } from '@app/core/async-services/http/versioned/interfaces/chat.interface';

export interface State {
  contacts: EntityState<Chat.Contact>;
  recipients: NewChatRecipient[];
}

export const initialState: State = {
  contacts: contactAdapter.getInitialState(),
  recipients: [],
};
